import type {DriverJob} from './schemas'

type DriverStockEquipmentGroup = DriverJob['stockEquipmentGroups'][number]

export function deliveryCountsLabel(
    group: Pick<
        DriverStockEquipmentGroup,
        'assignedQuantity' | 'deliveredQuantity' | 'remainingQuantity' | 'returnedQuantity'
    >,
): string {
    const parts = [`Assigned ${group.assignedQuantity}`]
    if (group.returnedQuantity > 0) {
        parts.push(
            `Came back ${group.returnedQuantity}`,
            `Still on site ${group.deliveredQuantity}`,
        )
    } else {
        parts.push(`Delivered ${group.deliveredQuantity}`)
    }
    if (group.remainingQuantity > 0) {
        parts.push(`Remaining to deliver ${group.remainingQuantity}`)
    }
    return parts.join(' · ')
}
